/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC } from 'react';
import styled, { css } from 'styled-components';

interface ProgressBarProps {
    currentQuestion: number;
    noOfQuestions: number;
}

interface StyledIndicatorProps {
    percentage: number;
}

const StyledProgressBar = styled.div`
    ${({ theme }) => css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: ${theme.space.md};
        font-size: 16px;

        @media (min-width: ${theme.breakpoints.sm}px) {
            margin-bottom: ${theme.space.lg};
        }
    `}
`;

const StyledIndicator = styled.div<StyledIndicatorProps>`
    ${({ theme, percentage }) => css`
        background: #eeeeee;
        height: ${theme.space.md};
        width: 100%;
        border-radius: ${theme.borderRadius.md};
        position: relative;
        overflow: hidden;

        &:after {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: ${percentage}%;
            background: ${theme.colors.green};
            transition: all ease-in-out 1s;
        }
        @media (min-width: ${theme.breakpoints.sm}px) {
            //padding: ${theme.space.lg};
        }
    `}
`;

const StyledStepsCounter = styled.div`
    ${({ theme }) => css`
        font-weight: bold;
        padding: 0 ${theme.space.md};
        flex-shrink: 0;
        @media (min-width: ${theme.breakpoints.sm}px) {
            //padding: ${theme.space.lg};
        }
    `}
`;

export const ProgressBar: FC<ProgressBarProps> = ({ currentQuestion, noOfQuestions }) => {
    const percentage = (currentQuestion / noOfQuestions) * 100;
    return (
        <StyledProgressBar>
            <StyledIndicator percentage={percentage} />
            <StyledStepsCounter>
                Question {currentQuestion} of {noOfQuestions}
            </StyledStepsCounter>
        </StyledProgressBar>
    );
};
